import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/brand-theme.css";
import App from "@/App";
import { restoreBrandThemeFromStorage } from "@/brand-theme";

/* Storage shim lives in public/index.html as an inline <script> that runs
 * BEFORE this bundle loads — so EVERY downstream localStorage access from
 * imported modules (react-router, react-query, etc.) is already wrapped.
 * Confirmed Jun 2026 from real iPad Safari 26.5 logs:
 *   boot_start (0ms) → index_js_start (301ms) → window_error (311ms)
 * with SecurityError firing INSIDE a React component, AFTER the in-bundle
 * shim installed. The fix is to install at HTML parse time, not after
 * module imports resolve.
 */

function reportBoot(kind, extra) {
  try {
    if (typeof window === 'undefined') return;
    if (window.__bs_report) {
      window.__bs_report(Object.assign({ kind: kind, stage: 'index.js' }, extra || {}));
      return;
    }
    let debugOn = false;
    try {
      debugOn = /[?&]debugSafari=1\b/.test(location.search) ||
                localStorage.getItem('__bs_debug') === '1';
    } catch (_) { /* shim might not be up yet */ }
    if (!debugOn) return;
    const payload = Object.assign({ kind: kind, stage: 'index.js' }, extra || {}, {
      ua: navigator.userAgent,
      url: location.href,
      route: location.pathname,
    });
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      try { navigator.sendBeacon('/api/client-debug-log', new Blob([body], { type: 'application/json' })); return; } catch (_) {}
    }
    fetch('/api/client-debug-log', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
  } catch (_) {}
}

reportBoot('MAIN_BUNDLE_STARTED');

try {
  restoreBrandThemeFromStorage();
} catch (e) {
  reportBoot('restore_theme_threw', { message: String(e && (e.message || e)) });
}

// Service Worker registration — gated by ?noSW=1 / sessionStorage.__bs_no_sw
// so we can diagnose whether the SW itself is causing boot failures on iPad.
function shouldRegisterSW() {
  try {
    if (sessionStorage.getItem('__bs_no_sw') === '1') return false;
    if (/[?&]noSW=1\b/.test(location.search)) return false;
  } catch (_) {}
  return 'serviceWorker' in navigator;
}

if (shouldRegisterSW()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then(() => reportBoot('SW_REGISTERED'))
      .catch((e) => reportBoot('SW_REGISTER_FAILED', { message: String(e && (e.message || e)) }));
  });
} else {
  reportBoot('SW_REGISTRATION_SKIPPED');
}

try {
  const rootEl = document.getElementById("root");
  if (!rootEl) {
    reportBoot('ROOT_ELEMENT_MISSING');
    throw new Error('#root element not found in index.html');
  }
  reportBoot('REACT_CREATE_ROOT');
  const root = ReactDOM.createRoot(rootEl);
  reportBoot('REACT_RENDER_START');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  reportBoot('REACT_RENDER_RETURNED');
} catch (e) {
  reportBoot('REACT_MOUNT_THREW', {
    message: String(e && (e.message || e)),
    stack: e && e.stack && e.stack.substring(0, 800),
    name: e && e.name,
  });
  throw e;
}
